module.exports = __webpack_public_path__ + "img/food_16.223680a8.jpg";